"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInputSelection = exports.setInputSelection = void 0;
function setInputSelection(input, start, end) {
    if ("selectionStart" in input && "selectionEnd" in input) {
        input.selectionStart = start;
        input.selectionEnd = end;
    }
    else {
        var range = input.createTextRange();
        range.collapse(true);
        range.moveStart("character", start);
        range.moveEnd("character", end - start);
        range.select();
    }
}
exports.setInputSelection = setInputSelection;
function getInputSelection(input) {
    var start = 0;
    var end = 0;
    if ("selectionStart" in input && "selectionEnd" in input) {
        start = input.selectionStart;
        end = input.selectionEnd;
    }
    else {
        var range = document.selection.createRange();
        if (range.parentElement() === input) {
            start = -range.moveStart("character", -input.value.length);
            end = -range.moveEnd("character", -input.value.length);
        }
    }
    return {
        start: start,
        end: end,
        length: end - start
    };
}
exports.getInputSelection = getInputSelection;
